import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { htmlSafe } from '@ember/template';
import { modifier } from 'ember-modifier';

export default class PaperDataTableDialogInner extends Component {
  @tracked left;
  @tracked top;
  @tracked width;

  _reposition = null;
  element = null;

  get style() {
    return htmlSafe(
      `left: ${this.left ?? ''}px;top: ${this.top ?? ''}px; min-width: ${this.width ?? ''}px;`,
    );
  }

  positionDialog() {
    let element = this.element;
    if (!element) {
      return;
    }

    // Derive the table container from the parent cell/row. With {{in-element}}
    // the dialog renders directly into the wormhole sink (never in-place inside
    // the table), so we cannot walk up from our own element.
    let cell = document.getElementById(this.args.parent);
    let mdTableContainer = cell && cell.closest('md-table-container');
    if (!cell || !mdTableContainer) {
      return;
    }

    let size = { width: element.clientWidth, height: element.clientHeight };
    let cellBounds = cell.getBoundingClientRect();
    let tableBounds = mdTableContainer.getBoundingClientRect();

    if (size.width > tableBounds.right - cellBounds.left) {
      this.left = tableBounds.right - size.width;
    } else {
      this.left = cellBounds.left;
    }

    if (size.height > tableBounds.bottom - cellBounds.top) {
      this.top = tableBounds.bottom - size.height;
    } else {
      this.top = cellBounds.top + 1;
    }

    this.width = this.args.row ? tableBounds.width : cellBounds.width;
  }

  afterRender() {
    this.positionDialog();
    let input = this.element && this.element.querySelector('input');
    if (input) {
      input.focus();
    }
  }

  setupElement = modifier((element) => {
    this.element = element;
    this._reposition = () => this.positionDialog();
    window.addEventListener('resize', this._reposition);
    this.afterRender();
  });

  willDestroy() {
    super.willDestroy();
    if (this._reposition) {
      window.removeEventListener('resize', this._reposition);
    }
  }
}
